import React, { useState, useEffect } from 'react';
import HeroSlider from '../features/HeroSlider';
import { fetchBlogs } from '../../services/api';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlogPosts = async () => {
      try {
        const response = await fetchBlogs(6); // Fetch 6 latest blog posts
        setBlogs(response.blogs);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setLoading(false);
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <div className="min-h-screen">
      <section className="relative w-full">
        <HeroSlider />
      </section>

      <div className="p-8 lg:p-18">
        {/* Hero Section */}
        <div className="container mx-auto px-4 py-8 sm:py-12 grid md:grid-cols-2 gap-6 sm:gap-8 items-center">
          <div className="md:order-1 order-2">
            <img 
              src="/assets/images/heros1.jpg" 
              alt="Agricultural Innovation in Nepal" 
              className="w-full h-[250px] sm:h-[350px] md:h-[400px] lg:h-[500px] object-cover rounded-lg shadow-lg"
            />
          </div>
          <div className="md:order-2 order-1">
            <h1 className="text-2xl sm:text-3xl font-bold text-blue-800 mb-3 sm:mb-4">
              Revolutionizing Nepal's Agricultural Landscape
            </h1>
            <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              We are transforming Nepal's agricultural sector from subsistence farming to a modern, industrialized system. Through comprehensive mechanization, advanced crop management, and sustainable practices, we're creating a new era of agricultural prosperity in Nepal.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div className="bg-blue-50 p-3 sm:p-4 rounded-lg">
                <h3 className="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">Our Vision</h3>
                <p className="text-xs sm:text-sm text-gray-700">Industrialize Nepal's agriculture sector and make it globally competitive</p>
              </div>
              <div className="bg-blue-50 p-3 sm:p-4 rounded-lg">
                <h3 className="font-bold text-blue-800 mb-1 sm:mb-2 text-sm sm:text-base">Our Impact</h3>
                <p className="text-xs sm:text-sm text-gray-700">Empowering farmers with modern technology and sustainable practices</p>
              </div>
            </div>
          </div>
        </div>

        {/* Mission and Values Section */}
        <div className="container mx-auto px-4 py-8 sm:py-12">
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-white rounded-lg shadow-md p-4 sm:p-6">
              <div className="flex flex-col h-full">
                <div className="mb-4 sm:mb-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-[#1E4C9A] mb-2 sm:mb-4">Vision</h2>
                  <p className="text-gray-700 text-sm sm:text-base">
                  To become the leading catalyst for agricultural transformation in Nepal.
                  </p>
                </div>
                <div className="mb-4 sm:mb-6">
                  <h2 className="text-xl sm:text-2xl font-bold text-[#1E4C9A] mb-2 sm:mb-4">Mission</h2>
                  <p className="text-gray-700 text-sm sm:text-base">
                  "To revolutionize Nepal's agricultural sector by implementing sustainable practices, innovative technologies, and inclusive growth strategies to enhance economy"
                  </p>
                </div>
                <div className="mt-auto">
                  <h2 className="text-xl sm:text-2xl font-bold text-blue-700 mb-2 sm:mb-4">Core Values</h2>
                  <div className="grid grid-cols-1 xs:grid-cols-2 gap-2">
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Transperancy</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Integrity</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Team Spirit</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Accountability</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Innovative</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Sustainability</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Fairness</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Dynamism</span>
                    </div>
                    <div className="flex items-center text-blue-600 text-xs sm:text-sm">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-check mr-1 sm:mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="m9 12 2 2 4-4"></path>
                      </svg>
                      <span>Service</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src="/assets/images/heros.jpg" alt="Our Services" className="w-full h-[250px] sm:h-[350px] md:h-full object-cover"/>
            </div>
          </div>
        </div>

        {/* Latest Blog Posts Section */}
        <div className="mt-6 sm:mt-8 bg-white rounded-lg shadow-md p-4 sm:p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-[#1E4C9A]">Latest Blog Posts</h2>
            <Link to="/blog" className="text-[#1A8D32] hover:text-[#1E4C9A] transition-colors duration-300">
              View All →
            </Link>
          </div>
          
          {loading ? (
            <div className="flex justify-center items-center h-48">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1E4C9A]"></div>
            </div>
          ) : (
            <div className="relative">
              <div className="overflow-x-auto pb-4 hide-scrollbar">
                <div className="flex gap-6 min-w-full">
                  {blogs.map((blog) => (
                    <div key={blog.post_id} className="w-[300px] flex-shrink-0">
                      <div className="bg-white rounded-lg overflow-hidden border border-gray-100 hover:border-[#1A8D32] transition-all duration-300 h-full">
                        {blog.thumbnail_image && (
                          <div className="aspect-w-16 aspect-h-9">
                            <img
                              src={blog.thumbnail_image}
                              alt={blog.title}
                              className="w-full h-48 object-cover"
                            />
                          </div>
                        )}
                        <div className="p-4">
                          <p className="text-gray-500 text-sm mb-2">
                            {new Date(blog.created_at).toLocaleDateString()}
                          </p>
                          <h3 className="font-semibold text-lg text-gray-900 mb-2 line-clamp-2">
                            {blog.title}
                          </h3>
                          <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                            {blog.excerpt}
                          </p>
                          <Link
                            to={`/blog/${blog.post_id}`}
                            className="text-[#1A8D32] hover:text-[#1E4C9A] text-sm font-medium transition-colors duration-300"
                          >
                            Read More →
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <style jsx>{`
                .hide-scrollbar {
                  -ms-overflow-style: none;
                  scrollbar-width: none;
                }
                .hide-scrollbar::-webkit-scrollbar {
                  display: none;
                }
              `}</style>
            </div>
          )}
        </div>

        {/* Partnership Section */}
        <div className="mt-6 sm:mt-8 bg-white rounded-lg shadow-md p-4 sm:p-6">
          <h2 className="text-xl sm:text-2xl font-bold text-[#1E4C9A] mb-4 sm:mb-6">Strategic Partnerships</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src="/assets/images/heros2.jpeg" alt="Partnerships" className="w-full h-[250px] sm:h-[350px] md:h-full object-cover"/>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-[#1E4C9A]/10 p-4 rounded-lg hover:shadow-md transition-shadow">
                <div className="flex items-center mb-2">
                  <svg className="w-6 h-6 text-[#1A8D32] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                  <h3 className="font-semibold text-[#1E4C9A]">Government Agencies</h3>
                </div>
                <p className="text-sm text-gray-600">Collaborating with agricultural ministries and development agencies</p>
              </div>
              <div className="bg-[#1E4C9A]/10 p-4 rounded-lg hover:shadow-md transition-shadow">
                <div className="flex items-center mb-2">
                  <svg className="w-6 h-6 text-[#1A8D32] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h3 className="font-semibold text-[#1E4C9A]">International Organizations</h3>
                </div>
                <p className="text-sm text-gray-600">Partnering with global agricultural development organizations</p>
              </div>
              <div className="bg-[#1E4C9A]/10 p-4 rounded-lg hover:shadow-md transition-shadow">
                <div className="flex items-center mb-2">
                  <svg className="w-6 h-6 text-[#1A8D32] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                  </svg>
                  <h3 className="font-semibold text-[#1E4C9A]">Research Institutions</h3>
                </div>
                <p className="text-sm text-gray-600">Working with agricultural research and academic institutions</p>
              </div>
              <div className="bg-[#1E4C9A]/10 p-4 rounded-lg hover:shadow-md transition-shadow">
                <div className="flex items-center mb-2">
                  <svg className="w-6 h-6 text-[#1A8D32] mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <h3 className="font-semibold text-[#1E4C9A]">Financial Partners</h3>
                </div>
                <p className="text-sm text-gray-600">Collaborating with banks and financial institutions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;